import React, { useState } from 'react';
import { Button, FlexRow, Icon, IconSize, IconType, Spinner, SpinnerSize } from 'ui-toolkit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { generateClosingDisclosureAsync } from '../../../services/RestDocumentsService';
import styled from 'styled-components';

interface IGeneratePdfButton {
  orderId: string;
  setShowGenerateModal: (value: boolean) => void;
}

export const GeneratePdfButton: React.FC<IGeneratePdfButton> = ({ orderId, setShowGenerateModal }) => {
  const [inProgress, setInProgress] = useState(false);
  const [generatePDFSuccess, setGeneratePDFSuccess] = useState(false);
  const onGeneratePDF = async () => {
    setInProgress(true);
    setShowGenerateModal(true);
    await generateClosingDisclosureAsync(orderId);
    setInProgress(false);
    setGeneratePDFSuccess(true);
  };
  return (
    <StyledFlexRow>
      {inProgress && <Spinner size={SpinnerSize.small} />}
      {generatePDFSuccess && <Icon type={IconType.Check} size={IconSize.Small} />}
      <Button intent={'primary'} onClick={onGeneratePDF} data-test-id={'generate-PDF-button'}>
        <FlexRow gap={'spacing2'}>
          <FontAwesomeIcon icon={faPlus} />
          Generate PDF
        </FlexRow>
      </Button>
    </StyledFlexRow>
  );
};

const StyledFlexRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  align-items: center;
`;
